import { useState } from "react";
import "../styles/ContactUs.css";
import Loading from "../../src/components/Loading/Loading";
import Message from "../UsefulCompoments/Message";
import { base_url } from "../ReuableFunctions/Blogs";

const ContactusForm = ({formRef}) => {
  const [isSubmitting, setIsSubmitting] = useState(false); // New state variable
  const [messageData, setMessageData] = useState({
    type: "",
    message: "",
  }); // New state variable message

  const [isFormSubmitted, setIsFormSubmitted] = useState(false); // New state variable
  const initialFormState = {
    startupName: "",
    startupStage: "",
    targetMarketValidated: "false",
    hasCoFounder: "false",
    mvpBuilt: "false",
    hasFundsForThreeMonths: "false",
    contactNumber: "",
    founderEmail: "",
    evaluationType: "FREE",
    address: "",
    teamStrength: "false",
  };
  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if(name === "contactNumber"){
      const regex = /^[0-9+]*$/; // Allows numbers and (+)sign
      if (!regex.test(value)) {
        return; // Prevent updating state if invalid input
      }
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOptionSelect = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "hasCoFounder" && { teamStrength: value }),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${base_url}/core/lovencoders/startup-evaluation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json(); // parse JSON response

      if (response.status === 400) {
        let errorMessage = "";
        if (data?.message) {
          errorMessage += ` ${data.message} `;
        }
        if (data?.message && data?.errors) {
          if (typeof data.errors === "string") {
            errorMessage += ` ${data.errors}`;
          } else if (Array.isArray(data.errors)) {
            errorMessage += ` ${data.errors.join(", ")}`;
          } else if (typeof data.errors === "object") {
            errorMessage += Object.entries(data.errors)
              .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
              .join("; ");
          }
        }
        setMessageData({
          type: "error",
          message: errorMessage,
        });

        setIsFormSubmitted(true);
        return;
      }

      if (response.ok) {
        setIsFormSubmitted(true);
        setMessageData({
          type: "success",
          message: "Form submitted successfully!",
        });
        setFormData(initialFormState);
      } else {
        setIsFormSubmitted(true);
        setMessageData({
          type: "error",
          message: `Something went wrong.${data?.message || ""}`,
        });
      }
    } catch (error) {
      console.log("Error", error);
      setIsFormSubmitted(true);
      setMessageData({
        type: "error",
        message: `Something went wrong. ${error?.message || "Unknown error"}`,
      });
    }

    setIsSubmitting(false);
  };

  const handleCloseMessage = () => {
    setIsFormSubmitted(!isFormSubmitted);
    setIsSubmitting(false);
  };
  return (
    <>
      {isSubmitting && <Loading />}
      {isFormSubmitted && (
        <Message
          data={messageData}
          handleClick={handleCloseMessage}
        />
      )}
      <form id="contact-us-form" onSubmit={handleSubmit} ref={formRef}>
        <div id="contact-us-form-innercontainer">
          <div className="form-title">Start Your Journey</div>
          <div className="form-desc">
            Fill in your details to uncover personalized insights. It only takes
            a minute!
          </div>
          <div className="form-input-container">
            <div className="form-input-field-container">
              <div className="input-container">
                <label htmlFor="startupName">
                  Startup Name <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  name="startupName"
                  id="startupName"
                  placeholder="Enter Startup Name"
                  value={formData.startupName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="startupStage">Startup Stage</label>
                <select
                  name="startupStage"
                  id="startupStage"
                  onChange={handleChange}
                >
                  <option value="">Select Stage</option>
                  <option value="Idea Stage">Idea Stage</option>
                  <option value="Valley Stage">Valley Stage</option>
                  <option value=">Growth Stage">Growth Stage</option>
                </select>
                {/* <input
                  type="text"
                  name="startupStage"
                  id="startupStage"
                  placeholder="Enter Startup Stage"
                  value={formData.startupStage}
                  onChange={handleChange}
                  required
                /> */}
              </div>
            </div>
            <div className="form-input-field-container">
              <div className="input-container">
                <label htmlFor="startupName">
                  Contact Number <span className="danger">*</span>
                </label>
                <input
                  type="text"
                  name="contactNumber"
                  id="contactNumber"
                  placeholder="+91XXXXXXXXXX"
                  value={formData.contactNumber}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="founderEmail">
                  Email Id <span className="danger">*</span>
                </label>
                <input
                  type="email"
                  name="founderEmail"
                  id="founderEmail"
                  placeholder="Enter Email Id"
                  value={formData.founderEmail}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="form-input-field-container">
              {/* <div className="input-container">
                <label htmlFor="founderName">Founder Name</label>
                <input
                  type="text"
                  name="founderName"
                  id="founderName"
                  placeholder="Enter Founder Name"
                  value={formData.founderName}
                  onChange={handleChange}
                  required
                />
              </div> */}
              {/* <div className="input-container">
                <label htmlFor="runwayLeftMonths">Runway Left Months</label>
                <input
                  type="number"
                  name="runwayLeftMonths"
                  id="runwayLeftMonths"
                  placeholder="Enter Runway Left Months"
                  value={formData.runwayLeftMonths}
                  onChange={handleChange}
                  required
                />
              </div> */}
            </div>
            <div className="form-text-field-container">
              <label htmlFor="address">Address</label>
              <input
                type="text"
                name="address"
                id="address"
                placeholder="Enter Address"
                value={formData.address}
                onChange={handleChange}
              />
            </div>
            <div className="form-assessment-container">
              <label>Self Assessment</label>
              {[
                {
                  question: "Have you validated your target market?",
                  field: "targetMarketValidated",
                },
                {
                  question: "Do you have a co-founder/team?",
                  field: "hasCoFounder",
                },
                { question: "Have you built an MVP?", field: "mvpBuilt" },
                {
                  question:
                    "Do you have enough funds for 3 months of operations?",
                  field: "hasFundsForThreeMonths",
                },
              ].map(({ question, field }, index) => (
                <div key={index} className="form-assessment-input-container">
                  <div className="form-assessment-input-question">
                    {index + 1}. {question}
                  </div>
                  <div className="form-assessment-options-container">
                    <div
                      className={`form-assessment-option ${
                        formData[field] === "false" ? "selected" : ""
                      }`}
                      onClick={() => handleOptionSelect(field, "false")}
                      style={{
                        backgroundColor:
                          formData[field] === "false"
                            ? "rgba(199, 49, 61, 1)"
                            : "",
                        color: formData[field] === "false" ? "white" : "",
                      }}
                    >
                      No
                    </div>
                    <div
                      className={`form-assessment-option ${
                        formData[field] === "true" ? "selected" : ""
                      }`}
                      onClick={() => handleOptionSelect(field, "true")}
                      style={{
                        backgroundColor:
                          formData[field] === "true"
                            ? "rgba(199, 49, 61, 1)"
                            : "",
                        color: formData[field] === "true" ? "white" : "",
                      }}
                    >
                      Yes
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div>
              <button
                type="submit"
                className="contact-btn form-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ContactusForm;
